module.exports = __webpack_public_path__ + "img/8.710b440d.png";